"use client";
import { useState, useEffect } from "react";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import AnimatedText from "@/components/common/AnimatedText";
import Image from "next/image";
import { BiSolidQuoteAltRight } from "react-icons/bi";

export default function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [webContentData, setWebContentData] = useState(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch('/api/Testimonials');
        const webContentResponse = await fetch('/api/web-content');
        if (response.ok) {
          const data = await response.json();
          setTestimonials(data);
        }
        if (webContentResponse.ok) {
          const data = await webContentResponse.json();
          setWebContentData(data);
        }
      } catch (error) {
        console.error('Failed to fetch Testimonials:', error);
      }
    };
    fetchTestimonials();
  }, []);

  const swiperOptions = {
    spaceBetween: 30,
    speed: 2000,
    loop: true,
    modules: [Autoplay, Navigation],
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".snbp2",
      prevEl: ".snbn2",
    },
  };
  return (
    <section className="testimonials-section">
      <div className="container-fluid">
        <div className="row align-items-start testimonials-row justify-content-center">
          {/* Left Content */}
          <div className="col-xl-5 col-lg-5 col-md-12">
            <div className="testimonials-left">
              <div className="testimonials-mini-title">
                <span className="testimonials-dot"></span>
                <span>Our Testimonials</span>
              </div>

              <h2 className="testimonials-main-title">
                Real experiences
                <br />
                from real people
              </h2>

              <p className="testimonials-desc">
                At Arena Water Park, every splash tells a story. From thrilling slides to unforgettable moments with family and friends, our guests leave with memories that last a lifetime. Here’s what some of them had to say!
              </p>

              <a href="/register" className="testimonials-btn">
                Get Started
              </a>
            </div>
          </div>

          {/* Right Slider */}
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="testimonial-slider-wrap">
              <Swiper
                {...swiperOptions}
                className="swiper testimonial-slider mt-4 mt-lg-0"
              >
                {testimonials.map((item, index) => (
                  <SwiperSlide className="swiper-slide" key={item._id || index}>
                    <div className="testimonial-card">
                      <div className="row g-0 align-items-center">
                        <div className="col-md-4">
                          <div className="testimonial-image-wrap">
                            <div className="image-anime">
                              <img
                                src={item.image || "/assets/img/useravatar.jpg"}
                                alt={item.name || "testimonial"}
                                className="testimonial-image"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-8">
                          <div className="testimonial-content-box">
                            <h3 className="testimonial-title">
                              {item.name || "Our family's favorite weekend escape!"}
                            </h3>

                            <p className="testimonial-text">
                              “{item.description}”
                            </p>

                            <div className="testimonial-divider"></div>

                            <div className="testimonial-footer">
                              <div className="testimonial-quote-icon">
                                <BiSolidQuoteAltRight />
                              </div>

                              <div className="testimonial-user-info">
                                <span className="testimonial-designation">
                                  {item.designation || "Mother of Two"}
                                </span>
                                <h5 className="testimonial-name">
                                  {item.name || "Nkechi Amadi"}
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
    // <section className="testimonial-section fix section-padding section-bg">
    //   <div className="arrow-shape float-bob-y">
    //     <Image
    //       src="/assets/img/arrow-shape.png"
    //       width={202}
    //       height={291}
    //       alt="img"
    //     />
    //   </div>
    //   <div className="building-shape float-bob-x">
    //     <Image
    //       src="/assets/img/testbg2.png"
    //       width={931}
    //       height={520}
    //       alt="img"
    //     />
    //   </div>
    //   <div className="testimonial-image">
    //     <Image
    //       src="/assets/img/testibg.jpg"
    //       width={745}
    //       height={708}
    //       alt="img"
    //     />
    //   </div>
    //   <div className="container">
    //     <div className="testimonial-wrapper">
    //       <div className="row g-4">
    //         <div className="col-lg-7">
    //           <div className="testimonial-content">
    //             <div className="section-title">
    //               <h6 className="wow fadeInUp">
    //                 <i className="fa-regular fa-arrow-left-long" />
    //                 testimonials
    //                 <i className="fa-regular fa-arrow-right-long" />
    //               </h6>
    //               <h2 className="text-white splt-txt wow">
    //                 <AnimatedText text="Real Stories from Real Water Park Lovers" />
    //               </h2>
    //             </div>
    //             <Swiper
    //               {...swiperOptions}
    //               className="swiper testimonial-slider mt-3 mt-md-0"
    //             >
    //               {testimonials.map((item, index) => (
    //                 <SwiperSlide className="swiper-slide" key={item._id || index}>
    //                   <div className="testi-content">
    //                     <div className="icon">
    //                       <svg
    //                         xmlns="http://www.w3.org/2000/svg"
    //                         width={32}
    //                         height={32}
    //                         viewBox="0 0 32 32"
    //                         fill="none"
    //                       >
    //                         <path d="M0 4V28L12 16V4H0Z" fill="#931f36" />
    //                         <path d="M20 4V28L32 16V4H20Z" fill="#931f36" />
    //                       </svg>
    //                       <h4>{item.description}</h4>
    //                       <h5 className="mt-3 text-white">{item.name}</h5>
    //                       <span className="text-white">{item.designation}</span>
    //                     </div>
    //                   </div>
    //                 </SwiperSlide>
    //               ))}
    //             </Swiper>
    //             <div className="client-img-items">
    //               <div className="client-image-area">
    //                 <div className="client-img">
    //                   <Image
    //                     src="/assets/img/client-1.png"
    //                     alt="img"
    //                     width={81}
    //                     height={89}
    //                   />
    //                 </div>
    //                 <div className="client-img">
    //                   <Image
    //                     src="/assets/img/client-2.png"
    //                     alt="img"
    //                     width={81}
    //                     height={89}
    //                   />
    //                 </div>
    //                 <div className="client-img">
    //                   <Image
    //                     src="/assets/img/client-3.png"
    //                     alt="img"
    //                     width={81}
    //                     height={89}
    //                   />
    //                 </div>
    //               </div>
    //               <div className="array-button">
    //                 <button className="array-prev snbp2">
    //                   <i className="fa-solid fa-arrow-left-long" />
    //                 </button>
    //                 <button className="array-next snbn2">
    //                   <i className="fa-solid fa-arrow-right-long" />
    //                 </button>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //         <div className="col-lg-6" />
    //       </div>
    //     </div>
    //   </div>
    // </section>
  );
}
